/*
 * FRENESI · Sacola: «Ganhe benefícios» — a jornada da compra (24/09/2026).
 *
 * Visual aprovado pelo dono: a frase do próximo benefício em destaque e todos
 * os marcos à vista, com o valor embaixo — frete grátis, decant de 2 ml, 5 ml
 * e 8 ml —, para o cliente entender que é uma régua.
 *
 * GET /api/publico/beneficios (no checkout.frenesiperfumes.com.br) traz a
 * régua do brinde e o mínimo do frete grátis — as MESMAS regras do checkout.
 * A jornada nasce escondida e só aparece com o brinde ligado; sem ela, a
 * barra de frete grátis do tema continua. A gaveta é redesenhada pelo tema a
 * cada mudança no carrinho; um observador redesenha a jornada quando ela
 * volta do servidor. Falha de rede nunca trava a sacola.
 */
(function () {
  'use strict';
  if (window.__frenesiSacola) return;
  window.__frenesiSacola = true;

  var API = 'https://checkout.frenesiperfumes.com.br/api/publico/';
  var CHAVE_BENEFICIOS = 'frenesi_beneficios_v2';
  var VALIDADE_BENEFICIOS_MS = 5 * 60 * 1000;

  var ICONE_FRETE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6.5h10v9H3zM13 9.5h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="16.5" cy="17.5" r="1.6"/></svg>';
  var ICONE_BRINDE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M12 8.5v12M18.5 12.5v6.5a1.5 1.5 0 0 1-1.5 1.5H7a1.5 1.5 0 0 1-1.5-1.5v-6.5"/><path d="M7.8 8.5a2.3 2.3 0 0 1 0-4.6C10.8 3.9 12 8.5 12 8.5s1.2-4.6 4.2-4.6a2.3 2.3 0 0 1 0 4.6"/></svg>';

  function brl(reais) {
    return Number(reais).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  /* «R$ 170» quando é redondo; «R$ 118,88» quando tem centavos. */
  function valorCurto(reais) {
    return brl(reais).replace(/,00$/, '');
  }

  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }

  /* ── A regra, do checkout ─────────────────────────────────────────── */

  var beneficiosPromessa = null;

  function beneficios() {
    if (beneficiosPromessa) return beneficiosPromessa;
    try {
      var guardado = JSON.parse(window.sessionStorage.getItem(CHAVE_BENEFICIOS) || 'null');
      if (guardado && Date.now() - guardado.em < VALIDADE_BENEFICIOS_MS) {
        beneficiosPromessa = Promise.resolve(guardado.dados);
        return beneficiosPromessa;
      }
    } catch (e) {}
    beneficiosPromessa = fetch(API + 'beneficios', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (dados) {
        try {
          window.sessionStorage.setItem(CHAVE_BENEFICIOS, JSON.stringify({ em: Date.now(), dados: dados }));
        } catch (e) {}
        return dados;
      })
      ['catch'](function () { beneficiosPromessa = null; return null; });
    return beneficiosPromessa;
  }

  /* Os marcos em ordem: o frete grátis (se houver) e a régua do brinde. */
  function marcos(dados) {
    var lista = [];
    var frete = dados && dados.frete;
    if (frete && Number(frete.minimo) > 0) lista.push({ tipo: 'frete', minimo: Number(frete.minimo), ml: null, comDesconto: frete.comDesconto === true });
    var faixas = (dados && dados.brinde && dados.brinde.faixas) || [];
    for (var i = 0; i < faixas.length; i++) {
      var m = Number(faixas[i] && faixas[i].minimo);
      var ml = Number(faixas[i] && faixas[i].ml);
      if (m > 0 && ml > 0) lista.push({ tipo: 'brinde', minimo: m, ml: ml });
    }
    return lista.sort(function (a, b) { return a.minimo - b.minimo; });
  }

  function nomeNaTela(m) {
    return m.tipo === 'frete' ? 'Frete grátis' : 'Decant ' + m.ml + ' ml';
  }

  /* ── A jornada ────────────────────────────────────────────────────── */

  function desenhar(caixa) {
    /* O total desenhado fica anotado: se o tema trocar só o `data-total` no
       mesmo nó, a diferença denuncia que é preciso desenhar de novo. */
    caixa.setAttribute('data-pronto', caixa.getAttribute('data-total') || '');
    beneficios().then(function (dados) {
      var ligado = dados && dados.brinde && dados.brinde.ligado === true;
      var lista = ligado ? marcos(dados) : [];
      if (!lista.length || !lista.some(function (m) { return m.tipo === 'brinde'; })) {
        caixa.hidden = true;
        caixa.setAttribute('data-ligado', '0');
        return;
      }
      caixa.setAttribute('data-ligado', '1');

      var total = Number(caixa.getAttribute('data-total') || 0) / 100;
      var proximo = -1;
      var ultimoAlcancado = -1;
      for (var i = 0; i < lista.length; i++) {
        lista[i].alcancado = total >= lista[i].minimo;
        if (lista[i].alcancado) ultimoAlcancado = i;
        else if (proximo < 0) proximo = i;
      }

      /* O título: «Ganhe benefícios» enquanto há o que ganhar; com tudo
         alcançado, «Benefícios garantidos» (dono, 24/09). */
      caixa.querySelector('[data-frenesi-jornada-titulo]').textContent = proximo < 0 ? 'Benefícios garantidos' : 'Ganhe benefícios';

      /* A frase: o próximo benefício, com o valor em destaque. */
      var frase = caixa.querySelector('[data-frenesi-jornada-frase]');
      frase.textContent = '';
      if (proximo < 0) {
        frase.textContent = 'Todos os benefícios desbloqueados.';
      } else {
        var alvo = lista[proximo];
        var jaTemBrinde = lista.some(function (m) { return m.tipo === 'brinde' && m.alcancado; });
        frase.appendChild(document.createTextNode('Mais '));
        frase.appendChild(el('b', null, valorCurto(Math.round((alvo.minimo - total) * 100) / 100)));
        frase.appendChild(document.createTextNode(
          alvo.tipo === 'frete'
            ? ' e o frete é por nossa conta.'
            : jaTemBrinde ? ' e seu decant vira ' + alvo.ml + ' ml.' : ' e um decant de ' + alvo.ml + ' ml é seu.'
        ));
      }

      /* Os marcos, com a linha que os liga. */
      var ol = caixa.querySelector('[data-frenesi-jornada-marcos]');
      ol.textContent = '';
      var meia = 50 / lista.length;
      var linha = el('span', 'frenesi-jornada__linha');
      linha.style.left = meia + '%';
      linha.style.right = meia + '%';
      ol.appendChild(linha);
      if (ultimoAlcancado > 0) {
        var feita = el('span', 'frenesi-jornada__linha-feita');
        feita.style.left = meia + '%';
        feita.style.width = (ultimoAlcancado / (lista.length - 1)) * (100 - 2 * meia) + '%';
        ol.appendChild(feita);
      }
      for (var j = 0; j < lista.length; j++) {
        var m = lista[j];
        var li = el('li', 'frenesi-jornada__marco' + (m.alcancado ? ' is-alcancado' : '') + (j === proximo ? ' is-proximo' : ''));
        li.setAttribute('aria-label', (m.tipo === 'frete' ? 'Frete grátis' : 'Decant ' + m.ml + ' ml') + ', a partir de ' + valorCurto(m.minimo) + (m.alcancado ? ', garantido' : j === proximo ? ', o próximo' : ''));
        var circulo = el('span', 'frenesi-jornada__circulo');
        circulo.setAttribute('aria-hidden', 'true');
        circulo.innerHTML = m.tipo === 'frete' ? ICONE_FRETE : ICONE_BRINDE;
        if (m.alcancado) circulo.appendChild(el('span', 'frenesi-jornada__check', '✓'));
        li.appendChild(circulo);
        if (j === proximo) {
          var pilula = el('span', 'frenesi-jornada__proximo', 'PRÓXIMO');
          pilula.setAttribute('aria-hidden', 'true');
          li.appendChild(pilula);
        }
        var nome = el('span', 'frenesi-jornada__nome', nomeNaTela(m));
        nome.setAttribute('aria-hidden', 'true');
        li.appendChild(nome);
        var valor = el('span', 'frenesi-jornada__valor', valorCurto(m.minimo));
        valor.setAttribute('aria-hidden', 'true');
        li.appendChild(valor);
        ol.appendChild(li);
      }

      /* As condições em tópicos, um grupo por benefício, montadas da mesma
         régua (mockup aprovado pelo dono, 24/09). O «conta o valor com as
         promoções» fica no brinde porque só vale para ele. */
      var texto = caixa.querySelector('[data-frenesi-jornada-texto]');
      texto.textContent = '';
      function grupo(titulo, topicos) {
        var g = el('div');
        g.appendChild(el('p', 'frenesi-jornada__grupo-titulo', titulo));
        var ul = el('ul', 'frenesi-jornada__topicos');
        for (var t = 0; t < topicos.length; t++) {
          var li = el('li');
          /* Cada tópico é uma lista de pedaços; os pares vão em negrito. */
          for (var p = 0; p < topicos[t].length; p++) {
            li.appendChild(p % 2 ? el('b', null, topicos[t][p]) : document.createTextNode(topicos[t][p]));
          }
          ul.appendChild(li);
        }
        g.appendChild(ul);
        texto.appendChild(g);
      }
      var frete = lista.filter(function (x) { return x.tipo === 'frete'; })[0];
      if (frete) {
        /* [dono, 20/10] Com o mínimo sobre o valor com desconto, a sacola não
           enxerga as promoções (o «leve 5 pague 4» é do checkout): o tópico
           avisa, e o checkout confirma. */
        grupo('Frete grátis', [
          ['A partir de ', valorCurto(frete.minimo), ' em produtos.'],
          frete.comDesconto
            ? ['Conta o valor dos produtos já com as promoções; o desconto do Pix e o cupom não tiram o frete grátis.']
            : null,
          ['Na opção de entrega mais econômica.']
        ].filter(Boolean));
      }
      var brindes = lista.filter(function (x) { return x.tipo === 'brinde'; });
      grupo('Decant de brinde', brindes.map(function (b) {
        return ['', b.ml + ' ml', ' a partir de ', valorCurto(b.minimo)];
      }).concat([
        ['Um brinde por pedido: vale o maior que a compra alcançar.'],
        ['Conta o valor final pago pelos produtos, já com todos os descontos (Pix, cupom e cashback).'],
        ['O perfume do decant é escolhido pela nossa equipe.']
      ]));

      caixa.hidden = false;
    });
  }

  /* «Condições dos benefícios» abre e fecha o texto. */
  document.addEventListener('click', function (ev) {
    var botao = ev.target && ev.target.closest && ev.target.closest('[data-frenesi-jornada-condicoes]');
    if (!botao) return;
    var caixa = botao.closest('[data-frenesi-jornada]');
    var texto = caixa && caixa.querySelector('[data-frenesi-jornada-texto]');
    if (!texto) return;
    texto.hidden = !texto.hidden;
    botao.setAttribute('aria-expanded', String(!texto.hidden));
  });

  /* ── Redesenho ────────────────────────────────────────────────────── */

  function varrer() {
    var caixas = document.querySelectorAll('[data-frenesi-jornada]');
    for (var i = 0; i < caixas.length; i++) {
      var c = caixas[i];
      if (c.getAttribute('data-pronto') !== (c.getAttribute('data-total') || '') || (c.hidden && c.getAttribute('data-ligado') === '1')) desenhar(c);
    }
  }

  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    window.requestAnimationFrame(function () { agendado = false; varrer(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();

  try {
    new MutationObserver(agendar).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-total', 'data-pronto', 'hidden']
    });
  } catch (e) {}
})();
